module.exports = __webpack_public_path__ + "2098ca36236e5bcb31d19515b1335c6d.svg";